// components/Login.js
import { useAuthenticator } from "@aws-amplify/ui-react"
import { Dialog } from "@mui/material"
import { ReactElement, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom"

import AuthProvider from "./authProvider"
import { IS_AUTHENTICATED } from "../constants/generalConstants"
import { BASE_URL } from "../router/routes"

interface LoginProps {
    initialState?: "signIn" | "signUp" | "forgotPassword"
}

/**
 * Houses application login screen. All protected routes redirect here in the
 * case where a user is not authenticated. It should be placed in the
 * application route.
 */
const Login = ({ initialState }: LoginProps): ReactElement => {
    const { route } = useAuthenticator((context) => [context.route])
    const location = useLocation()
    const navigate = useNavigate()

    const from = location.state?.from?.pathname
        ? `${location.state?.from?.pathname}${location.state?.from?.search}`
        : BASE_URL

    useEffect(() => {
        if (route === IS_AUTHENTICATED) {
            navigate(from, { replace: true })
        }
    }, [route, navigate, from])
    return (
        <Dialog fullScreen open>
            <AuthProvider initialState={initialState} />
        </Dialog>
    )
}
Login.defaultProps = {
    initialState: "signIn",
}
export default Login
